import {
  object, string, array, date, bool,
} from 'yup';

import { DEAL_TYPES, DEAL_STATUSES } from 'resources/deal/deal.constants';

const dealSchema = object({
  id: string(),
  created_on: date().required(),
  updated_on: date().required(),
  client_ids: array().of(string()).required(),
  realtor_id: string().required(),
  coordinator_id: string().required(),
  company_id: string().required(),
  team_id: string().nullable(),
  type: string().oneOf(Object.values(DEAL_TYPES)).required(),
  status: string().oneOf(Object.values(DEAL_STATUSES)).required(),
  // property that client want to buy or sell (depends on type)
  property: object({
    image_url: string().nullable(),
    address: object({
      line1: string().nullable(),
      line2: string().nullable(),
      city: string().nullable(),
      state: string().nullable(),
      zip: string().nullable(),
    }),
  }).nullable(),
  home_changes: array().nullable(),
  // user fills this criteria during the onboarding
  buying_criteria: object().shape({
    price_min: string().nullable(),
    price_max: string().nullable(),
    beds_number: string().nullable(),
    baths_number: string().nullable(),
    location: string().nullable(),
    school_system: string().nullable(),
    must_haves: array().of(string()).nullable(),
    square_feet_min: string().nullable(),
    square_feet_max: string().nullable(),
    lot_size_min: string().nullable(),
    lot_size_max: string().nullable(),
    year_built_min: string().nullable(),
    year_built_max: string().nullable(),
  }).nullable(),

  transaction: object({
    status: string().oneOf(Object.values(DEAL_STATUSES)).nullable(), // TODO: remove after deploy in production
    document_ids: array().of(string()).default([]), // TODO: remove one day
    finished_on: date().nullable(), // status became closed/voided

    // use 'string' instead of 'date' to avoid appending 'T00:00:00.000Z' to the date only value, like '2024-10-30'
    created_on: string().nullable(), // started_on is better naming
    closing_on: string().nullable(),
    individual_under_contract_date: string().nullable(),
  }).nullable(),

  advanced_fields: object().nullable(),

  note: string().nullable(), // admin/agent fills this note on the transaction page
  notes: string().nullable(), // client fills this notes during the onboarding

  is_sample: bool().default(false),

  due_date_calculation: object({
    exclude_weekends: bool().default(false),
    exclude_federal_holidays: bool().default(false),
    is_calculation_warning_dismissed: bool().default(false),
  }),
});

export default dealSchema;
